



























import Vue from 'vue'

export default Vue.extend({
  name: 'AuctionFooter',
  props: {
    procedureId: {
      type: String,
      required: true
    },
    validForm: {
      type: Boolean,
      required: true
    },
    currentStep: {
      type: Number,
      required: true
    },
    lastValidatedStep: {
      type: Number,
      required: true
    },
    validQuery: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      currentStepCopy: 1,
      lastValidatedStepCopy: 1,
      finishForm: false,
      lastStep: 7
    }
  },
  watch: {
    currentStep (newValue: number) {
      this.currentStepCopy = newValue
      this.checkFinishTab()
    },
    lastValidatedStep (newValue: number) {
      this.lastValidatedStepCopy = newValue
    }
  },
  mounted () {
    this.currentStepCopy = this.currentStep
    this.lastValidatedStepCopy = this.lastValidatedStep
    this.validMoving()
  },
  methods: {
    onMoving (direccion: string) {
      if (direccion === 'continuar') {
        this.onContinueWizard()
      } else if (direccion === 'volver') {
        this.onVoltarWizard()
      }

      window.scrollTo(0, 0)
    },

    onContinueWizard (): void {
      this.currentStepCopy++
      this.$emit('updateCurrentStep', this.currentStepCopy)

      if (this.lastValidatedStepCopy < this.currentStepCopy) {
        this.lastValidatedStepCopy = this.currentStepCopy
        this.$emit('updateLastValidatedStep', this.lastValidatedStepCopy)
      }

      this.validMoving()
    },

    onVoltarWizard (): void {
      this.currentStepCopy--
      this.$emit('updateCurrentStep', this.currentStepCopy)
      this.validMoving()
    },

    validMoving (): void {
      if (this.lastValidatedStepCopy === this.currentStepCopy) {
        this.$emit('updateValidForm', false)
      } else {
        this.$emit('updateValidForm', true)
      }

      this.checkFinishTab()
    },

    checkFinishTab (): void {
      if (this.currentStepCopy === this.lastStep) {
        this.finishForm = true
      } else {
        this.finishForm = false
      }
    },

    finishWizard (): void {
      this.$emit('finishWizard')
    }
  }
})
